import { create } from 'zustand'

import { useStoreLocalStorage } from './useStoreLocalStorage'

export type DatesState = {
  opened: boolean
  startAt: string | undefined
  endAt: string | undefined

  setStartAt: (startAt: string | undefined) => void
  setEndAt: (endAt: string | undefined) => void
  setDatesOpened: (opened: boolean) => void
}

const { setDatesStartAt, setDatesEndAt, getDatesStartAt, getDatesEndAt } =
  useStoreLocalStorage()

export const useStoreDates = create<DatesState>((set) => ({
  opened: false,
  startAt: getDatesStartAt(),
  endAt: getDatesEndAt(),

  setStartAt: (date?: string) => {
    set({ startAt: date })
    setDatesStartAt(date)
  },

  setEndAt: (date?: string) => {
    set({ endAt: date })
    setDatesEndAt(date)
  },

  setDatesOpened: (opened) => set({ opened }),
}))
